<portal-metrics-bar-visualizer
  [key]="key"
  [label]="label"
  [value]="percentValue"
  [vizMetric]="vizMetric"
  [totalItems]="totalItems"
  [otherItems]="otherItems"
  [tooltipPosition]="'bottom'">
</portal-metrics-bar-visualizer>
